import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing, MessageCircle, Save } from "lucide-react";
import { errText, fetchMyAlerts, ron, saveMyPhone } from "@/lib/bf";
import { DemoTag } from "./BFStockTotal";

export default function BFAgentAlerts() {
  const [a, setA] = useState(null);
  const [phone, setPhone] = useState("");
  useEffect(() => { fetchMyAlerts().then((d) => { setA(d); setPhone(d.phone ? `+${d.phone}` : ""); }).catch(() => {}); }, []);
  if (!a) return null;
  const msg = [a.msg_due, a.msg_low].filter(Boolean).join("\n\n");
  const save = () => saveMyPhone(phone).then((r) => { setA({ ...a, phone: r.phone }); setPhone(r.phone ? `+${r.phone}` : ""); toast.success("Număr salvat"); }).catch((e) => toast.error(errText(e, "Nu am putut salva")));
  return (
    <section className="invite-box" data-testid="bf-agent-alerts">
      <h3><BellRing size={18} /> Azi pentru tine <DemoTag /></h3>
      <div className="bf-alert-cols">
        <div data-testid="bf-alert-due">
          <h4>Scadente azi ({a.due.length})</h4>
          {!a.due.length && <p className="st-hint">Nicio factură nu ajunge azi la scadență.</p>}
          {a.due.map((d) => <p key={d.no} className="bf-alert-line"><span>{d.salon} · {d.no}</span><b>{ron(d.balance)}</b></p>)}
        </div>
        <div data-testid="bf-alert-low">
          <h4>Stoc mic, sub {a.threshold} buc. ({a.low.length})</h4>
          {!a.low.length && <p className="st-hint">Produsele comandate de saloanele tale au stoc suficient.</p>}
          {a.low.slice(0, 12).map((x) => <p key={x.code} className="bf-alert-line"><span>{x.name}</span><b className={x.total ? "" : "is-out"}>{x.total} buc.</b></p>)}
          {a.low.length > 12 && <p className="st-hint">…și încă {a.low.length - 12} produse în mesajul WhatsApp.</p>}
        </div>
      </div>
      <div className="share-actions">
        <label className="bf-inv-field"><span>Numărul tău de WhatsApp</span><input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="07xx xxx xxx" data-testid="bf-alert-phone" /></label>
        <button type="button" className="st-btn st-btn--ghost" onClick={save} data-testid="bf-alert-phone-save"><Save size={14} /> Salvează</button>
        {msg && <a className="st-btn st-btn--light" href={`https://wa.me/${a.phone || ""}?text=${encodeURIComponent(msg)}`} target="_blank" rel="noopener noreferrer" data-testid="bf-alert-wa"><MessageCircle size={14} /> Trimite-mi pe WhatsApp</a>}
      </div>
    </section>
  );
}
